export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "mtproto.worker.6ad38cb937df18c36f24.bundle.worker.js");
}
